<template>
    <div>
        <h1>404</h1>
        <p>this page not found!</p>
        <b-button @click="routerToHome">Go Back Home</b-button>
    </div>
</template>

<script>
export default {
    methods: {
        routerToHome() {
      this.$router.push({ name: 'Home' })
        }
    }
}
</script>